import { post } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { APP_CONFIG } from '@/config';
import { StartAinavioAssistantChatResponse } from '@/@types/ainavioAssistant';
import { GeneralApiError } from '@/domain/errors/GeneralApiError';

export const startAinavioAssistantChat = async (): Promise<StartAinavioAssistantChatResponse> => {
  const response = await post<StartAinavioAssistantChatResponse, undefined>(
    `${APP_CONFIG.baseApiUrl}${ApiEndpoints.ainavioAssistantStartChat}`,
    undefined,
    'XSRF-TOKEN',
  );
  if (response != null) return response;
  throw new GeneralApiError();
};
